import React, { Fragment } from 'react'
import './Title.less'
import { goIndex } from '@/assets/js/utils'

function Title ({ buriedPointEvent, data: { trackId, position, style = {}, sublist = [] } }) {
    if (!style) style = {}
    const {
        backgroundColor,
        textColor,
        backgroundPicUrl
    } = style
    return (
        <Fragment>
            {sublist.map(({ id, url, keyword, title, subtitle }, index) => (
                <div
                    className="title statistics-dom"
                    key={id}
                    onClick={() => {
                        buriedPointEvent({
                            button_name: `${trackId}`,
                            button_id: `${id}`,
                            button_order: `${index + 1}`,
                            area_order: position,
                            button_area: `${position}-${trackId}`
                        })
                        goIndex(url, trackId, keyword)
                    }}
                    style={{
                        backgroundColor,
                        color: textColor,
                        backgroundImage: backgroundPicUrl ? `url(${backgroundPicUrl})` : ''
                    }}>{title || subtitle || '默认标题'}</div>
            ))}
        </Fragment>
    )
}

export default Title
